import { boolean, strictObject, string, z } from 'zod';

export const feedbackInputSchema = strictObject({
  path: string().min(0),
  helpful: boolean(),
  message: string().optional().nullable(),
});

export type FeedbackInputDto = z.infer<typeof feedbackInputSchema>;
